"use strict";
// A web interface to manage a trail guide mobile app's content and data.
// Copyright (C) 2021-2025  David Lougheed
// See NOTICE for more information.
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchAssetTypesIfNeeded = exports.UPDATE_ASSET_TYPE = exports.ADD_ASSET_TYPE = exports.FETCH_ASSET_TYPES = void 0;
var utils_1 = require("../../utils");
exports.FETCH_ASSET_TYPES = (0, utils_1.networkActionTypes)("FETCH_ASSET_TYPES");
exports.ADD_ASSET_TYPE = (0, utils_1.networkActionTypes)("ADD_ASSET_TYPE");
exports.UPDATE_ASSET_TYPE = (0, utils_1.networkActionTypes)("UPDATE_ASSET_TYPE");
var fetchAssetTypes = (0, utils_1.networkAction)(exports.FETCH_ASSET_TYPES, "/asset_types");
exports.fetchAssetTypesIfNeeded = (0, utils_1.makeIfNeededAction)(fetchAssetTypes, "assetTypes");
